import { ORGANIZATION_ID } from "@/constants/local-storage";

/**
 * Reads the active organization logical id from browser `localStorage` under {@link ORGANIZATION_ID}.
 *
 * Returns `undefined` during SSR, when `localStorage` is unavailable, when access throws
 * (private mode, disabled storage), or when the stored value is missing or empty.
 */
export function readBrowserStoredOrganizationId(): string | undefined {
  if (typeof globalThis === "undefined" || !("localStorage" in globalThis)) {
    return undefined;
  }
  try {
    const id = globalThis.localStorage.getItem(ORGANIZATION_ID);
    return id && id.length > 0 ? id : undefined;
  } catch {
    return undefined;
  }
}
